import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { strings } from '../../../localization/strings'
import Loader from '../../loaders'
import { makeStyles, Button, Dialog, DialogTitle, DialogContent } from '@material-ui/core'
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import { getNews, setNewAsView } from '../../../helpers/restHelpers'
import { logOutAction } from '../../../actions/usersActions'
import { cleanStatusAction } from '../../../actions/appActions'

const useStyles = makeStyles({
    alertContainer: {
        backgroundColor: '#b6780e',
    },
    alert: {
        height: '80vh',
        textAlign: 'center',
    },
    alertContent: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
    },
    alertTitle: {
        backgroundColor: '#f7b500',
        color: '#fff',
        textAlign: 'center',
        height: '150px',
        fontSize: '50px',
    },
    alertText: {
        width: '70%',
        margin: '50px auto',
    },
    alertIcon: {
        fontSize: '80px',
        color: '#d43f3a',
    },
    agreeBtn: {
        margin: '20px auto',
    }
})

const CriticalNews = (props) => {
    const styles = useStyles()
    const [isLoading, setIsLoading] = useState(true)
    const [criticalNew, setCriticalNew] = useState();

    const getAllNews = async () => {
        const response = await getNews()
        setCriticalNew(response.find(x => x.type === 3 && !x.read))
        setIsLoading(false)
    }

    const handleAgree = async () => {
        setIsLoading(true)
        if (!criticalNew.viewTS) await setNewAsView(criticalNew.id)
        handleLogOut();
    }

    const handleLogOut = () => {
        props.logOutAction(props.history);
        props.cleanStatusAction();
    }

    useEffect(() => {
        getAllNews();
    }, []);

    return (
        <div>
            {isLoading ? (<Loader />) : (
                <Dialog
                    className={styles.alertContainer}
                    open={true}
                    maxWidth={'xl'}
                    fullWidth={true}
                >
                    <DialogTitle className={styles.alertTitle} disableTypography>
                        <HighlightOffIcon className={styles.alertIcon} /><br />
                        {strings.criticalNew.title}
                    </DialogTitle>
                    <DialogContent dividers={false} className={styles.alert}>
                        <div id="scroll-dialog-description" className={styles.alertContent}>
                            <div id='alertText' dangerouslySetInnerHTML={{ __html: criticalNew.text }} className={styles.alertText}>
                            </div>
                            <Button
                                onClick={handleAgree}
                                variant="contained"
                                //disabled={!checked ? true : false}
                                color="primary"
                                className={styles.agreeBtn}
                            >
                                {strings.criticalNew.closeBtn}
                            </Button>
                        </div>
                    </DialogContent>
                </Dialog>
            )}
        </div>
    )
}
const mapStateToProps = (store) => ({})
const mapDispatchToProps = { logOutAction, cleanStatusAction }
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(CriticalNews))
